import React from "react";
import { useBetSlip } from "../providers/BetSlipProvider";
import { useWidgetContext } from "../providers/WidgetProvider";
import { StateActionTypes } from "../types/enums";
import { useI18n } from "../providers/I18nProvider";

export const Actions: React.FC = () => {
  const { dispatch } = useWidgetContext();
  const { betSlipState, clearAllSelections } = useBetSlip();
  const { t, tHtml } = useI18n();

  const handleClearAll = () => {
    clearAllSelections();
  };

  const handleAutoAcceptChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Always use TOGGLE_ACCEPT_ODDS_CHANGES to update the checkbox state
    dispatch({
      type: StateActionTypes.TOGGLE_ACCEPT_ODDS_CHANGES,
      payload: e.target.checked,
    });

    // If enabling, also accept any current odds changes
    if (e.target.checked) {
      dispatch({ type: StateActionTypes.ACCEPT_ODDS_CHANGES });
    }
  };

  const isDisabled =
    betSlipState.selections.length === 0 &&
    betSlipState.betBuilderState.bets.length === 0;

  return (
    <div className="flex items-center justify-between py-[19px] relative">
      {/* Accept Odds Changes */}
      <div className="flex items-center space-x-3">
        <div className="flex items-center space-x-1">
          <input
            id="accept-odds-changes"
            type="checkbox"
            checked={betSlipState?.acceptOddsChanges}
            onChange={handleAutoAcceptChange}
            className="w-4.5 h-4.5 text-primary border rounded accent-input-accent"
          />
          <label htmlFor="accept-odds-changes" className="text-sm">
            {t("BetSlipAcceptChanges")}
          </label>
          <div className="flex relative">
            <i className="au-i-info-thin-circle peer"></i>
            <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs rounded py-1 px-2 opacity-0 peer-hover:opacity-100 transition-opacity whitespace-nowrap"
            dangerouslySetInnerHTML={tHtml("BetSlipAcceptChangesInformation")}
            />
          </div>
        </div>
      </div>

      {/* Remove All */}
      <button
        onClick={handleClearAll}
        disabled={isDisabled}
        className="flex items-center space-x-1 text-sm disabled:text-disabled"
      >
        <span>{t("BetSlipRemoveAll").replace(/\s*\{[^}]+\}/g, "").trim()}</span>
        <i className="au-m-ico-c au-i-trash-gsb"></i>
      </button>
    </div>
  );
};

export default Actions;
